import {
  Alert,
  Badge,
  Box,
  Button,
  Group,
  Modal,
  ScrollArea,
  Table,
  Text,
  Textarea,
} from '@mantine/core';
import { CommentedRow } from 'utils/assessmentRemarks';

function CommentTable({ rows }: { rows: CommentedRow[] }) {
  return (
    <ScrollArea.Autosize mah="45vh">
      <Table withBorder withColumnBorders verticalSpacing="xs" fontSize="sm">
        <thead>
          <tr>
            <th style={{ width: 70 }}>Code</th>
            <th>Question</th>
            <th style={{ width: 80 }}>Status</th>
            <th>Trainer comment</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td>
                <b>{row.code ?? '-'}</b>
              </td>
              <td>
                <Text lineClamp={2}>{row.question}</Text>
                {row.subQuestion && (
                  <Text size="xs" color="dimmed" lineClamp={2}>
                    {row.subQuestion}
                  </Text>
                )}
              </td>
              <td>
                <Badge color={row.status === 'NYC' ? 'red' : 'green'}>{row.status || '-'}</Badge>
              </td>
              <td style={{ whiteSpace: 'pre-wrap' }}>{row.comment}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ScrollArea.Autosize>
  );
}

type RemarkReviewModalProps = {
  opened: boolean;
  rows: CommentedRow[];
  remark: string;
  onRemarkChange: (value: string) => void;
  onAdd: () => void;
  onSkip: () => void;
  onCancel: () => void;
};

export function RemarkReviewModal({
  opened,
  rows,
  remark,
  onRemarkChange,
  onAdd,
  onSkip,
  onCancel,
}: RemarkReviewModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={<b>Did you forget the final remarks?</b>}
      size="xl"
      centered
      zIndex={1000}
    >
      <Alert color="yellow" title="Oral Recovery (OR) remarks missing?" mb="md">
        You left comments on {rows.length} question{rows.length === 1 ? '' : 's'} below, but the
        final Remarks by Assessor is empty. Did you forget to note which questions had Oral Recovery
        (OR)?
      </Alert>
      <CommentTable rows={rows} />
      <Textarea
        mt="md"
        label="Remarks by Assessor"
        value={remark}
        onChange={(event) => onRemarkChange(event.currentTarget.value)}
        autosize
        minRows={2}
      />
      <Group position="right" mt="md">
        <Button type="button" variant="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="button" variant="default" onClick={onSkip}>
          Continue without remark
        </Button>
        <Button type="button" onClick={onAdd} disabled={!remark.trim()}>
          Continue &amp; add remark
        </Button>
      </Group>
    </Modal>
  );
}

export function NycReminder({ rows }: { rows: CommentedRow[] }) {
  return (
    <Box
      mt="md"
      p="md"
      sx={{ background: '#fff4e0', border: '1px solid #f5a623', borderRadius: 6 }}
    >
      <Text weight={700} color="orange.8" mb={4}>
        Reminder: still marked NYC
      </Text>
      <Text size="sm" mb="sm">
        These questions are marked NYC but have remarks. If the learner passed the oral recovery,
        change the status to C before submitting.
      </Text>
      <CommentTable rows={rows} />
    </Box>
  );
}
